import React, { useState } from 'react';
import { BodyTextTW, BoldBodyTextTW } from 'tailwindComponents/bodyText/BodyTextTW';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { GiactModal } from './GiactModal';
import { GiactStatusPill } from './GiactStatusPill';
import { IGiactResponse } from 'types/order/escrow/request/IGiactRequest';
import { Tooltip } from 'ui-toolkit';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GiactVerificationResponse } from './GiactVerificationResponse';
import { useHasPermissions } from '../../../../../accessControl/hooks/useHasPermissions';
import { DateFormat, getDateString } from '../../../../../../ui-toolkit/utilities/getDateString';

export interface IGiactContainerProps {
  beneficiaryName?: string;
  accountId?: string;
  accountNumber?: string;
  routingNumber: string;
  routingBankName?: string;
  disbursementType: string;
  disbursementId: string;
  isReadOnly: boolean;
  giact?: IGiactResponse;
}

export const GiactContainer: React.FC<IGiactContainerProps> = (props) => {
  const hasGIACTReadPermission = useHasPermissions([ePermissions.GIACTRead]);
  const hasGIACTEditPermission = useHasPermissions([ePermissions.GIACTEdit]);

  const [showGIACTModal, setShowGIACTModal] = useState(false);
  const showSendGiactButton = hasGIACTEditPermission && !props.isReadOnly;

  if (!hasGIACTReadPermission) {
    return null;
  }
  return (
    <>
      <div className={'flex basis-full flex-row items-center'}>
        <BodyTextTW>Account Verification</BodyTextTW>
        {showSendGiactButton && (
          <ButtonTW
            className={'ml-2'}
            secondary
            onClick={() => setShowGIACTModal(true)}
            data-test-id={'open-giact-button'}
          >
            Send to GIACT
          </ButtonTW>
        )}
        <div className={'ml-2 grow border-b-2 border-gray-300'} />
        {props.giact && (
          <>
            <GiactStatusPill giactStatus={props.giact.giactStatus} />
            <Tooltip
              tooltipContent={<GiactVerificationResponse data={props.giact} />}
              trigger={'hover'}
              placement={'top'}
            >
              <FontAwesomeIcon icon={faQuestionCircle} size={'lg'} className={'ml-2'} />
            </Tooltip>
          </>
        )}
        {showGIACTModal && <GiactModal {...props} onClose={() => setShowGIACTModal(false)} />}
      </div>
      {(props.giact?.requestedAt || props.giact?.description) && (
        <div className={'flex flex-row'}>
          {props.giact?.requestedAt && (
            <div>
              <BoldBodyTextTW>Requested:</BoldBodyTextTW>{' '}
              <BodyTextTW>{getDateString(DateFormat.shortDateTime, props.giact.requestedAt, false)}</BodyTextTW>
            </div>
          )}
          {props.giact?.description && (
            <div className={'ml-4'}>
              <BoldBodyTextTW>Description:</BoldBodyTextTW>
              <BodyTextTW>{props.giact.description}</BodyTextTW>
            </div>
          )}
        </div>
      )}
    </>
  );
};
